import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
// import { MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { BehaviorSubject, fromEvent, merge, Observable, of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, switchMap, take, tap } from 'rxjs/operators';
import { LayoutUtilsService, MessageType, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { ActivatedRoute, Router } from '@angular/router';
import { SubheaderService } from '../../../../../core/_base/layout';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CompanyService } from '../../../../../core/auth/_services/company.service';

@Component({
  selector: 'kt-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss']
})
export class SimpleTableComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges {

  datasource: MatTableDataSource<any>;
  displayedColumns: string[] = [];
  @Input() columnList: any[];
  @Input() name: string;
  @Input() defaultSortActive: string;
  @Input() defaultSortDirection: 'asc' | 'desc' | '';
  @Input() pluralName: string;
  @Input() route: string;
  @Input() filterList: any[];
  @Input() actions: any = {edit: true, add: true, delete: true};
  @Input() dataObs: Subject<QueryResultsModel>;
  @Input() deleteObs: Subject<string>;
  @Input() actionBtns: any[] = [];
  @Input() editRoute: string = null;
  @Input() addRoute: string = null;
  @Input() expandableRows: boolean = false;
  @Input() detailTemplate: TemplateRef<any>;
  @Input() tableMinWidth: string = null;
  @Input() actionCellTemplate: TemplateRef<any>;
  @Input() cellTemplates: {[key: string]: TemplateRef<any>} = {};

  // @Input() deleteOne: (item: any) => Observable<string>;
  // @Input() getPage: (query: QueryParamsModel) => Observable<QueryResultsModel>;

  @Output() getPageEvent = new EventEmitter<QueryParamsModel>();
  @Output() deleteOneEvent = new EventEmitter<number>();

  private subscriptions: Subscription[] = [];
  @ViewChild(MatPaginator, {static:false}) paginator: MatPaginator;
	@ViewChild('sort1', {static: true}) sort: MatSort;
  // @ViewChild('searchInput', {static: true}) searchInput: ElementRef;

  itemList: any[] = [];
  itemCount = 0;
  isLoading = true;
  expandedElement: any = null;
  
  constructor(
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private subheaderService: SubheaderService,
    private layoutUtilsService: LayoutUtilsService,
    private cdr: ChangeDetectorRef,
    private companyService:CompanyService
	) { }

	getCurrentCompany(){
		const currentCompany = this.companyService.getCurrentCompany();
    if(currentCompany == null){
      return "Compañia sin definir"
    }
    return currentCompany.name;    
	}
  
	ngOnChanges(changes: SimpleChanges): void {
		this.displayedColumns = this.columnList.map(col=>col.def);
    if(this.expandableRows && this.detailTemplate){
      this.displayedColumns.unshift("expand");
    }
    this.displayedColumns.push("actions");
	}

  ngOnInit() {
		
  }

  /**
   * On Destroy
   */
  ngOnDestroy() {
    this.subscriptions.forEach(el => el.unsubscribe());
  }

  ngAfterViewInit() {
    console.log(`columnlist: ${JSON.stringify(this.columnList)}`);
    // If the user changes the sort order, reset back to the first page.
    const sortSubscription = this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    this.subscriptions.push(sortSubscription);

    /* Data load will be triggered in two cases:
    - when a pagination event occurs => this.paginator.page
    - when a sort event occurs => this.sort.sortChange
    **/
    const paginatorSubscriptions = merge(this.sort.sortChange, this.paginator.page).pipe(
      tap(() => this.loadItemList())
    )
      .subscribe();
    this.subscriptions.push(paginatorSubscriptions);

    // Filtration, bind to searchInput
    // const searchSubscription = fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
    //   debounceTime(150),
    //   distinctUntilChanged(),
    //   tap(() => {
    //     this.paginator.pageIndex = 0;
    //     this.loadItemList();
    //   })
    // )
    // .subscribe();
    // this.subscriptions.push(searchSubscription);

    // Set title to page breadCrumbs
    this.subheaderService.setTitle(this.pluralName);

    this.sort.direction = this.defaultSortDirection;
    this.sort.active = this.defaultSortActive;

    this.subscribeToLoadItem();
    this.loadItemList();

    // this.subheaderService.setTitle(this.pluralName);
		// this.subheaderService.setBreadcrumbs([
		// 	{ title: `Listado de ${this.pluralName}`, page: `${this.route}` },
		// 	// { title: 'part 2', page: `/ecommerce/products` },
		// 	// { title: 'part 3', page: `/ecommerce/products/edit`, queryParams: { id: 1 } }
		// ]);
    // // this.subheaderService.updateBreadcrumbs();
    // this.subheaderService.disabled$.next(false);
  }

  /**
   * Load Item List
   */
  loadItemList() {
     
    // this.selection.clear();
    // console.log(this.sort.active);
    const activeColumn = this.columnList.find(col=>col.def==this.sort.active);
    var sortActive = null;
    if(activeColumn) sortActive = activeColumn.def;
    const queryParams = new QueryParamsModel(
      this.filterConfiguration(),
      this.sort.direction,
      sortActive,
      this.paginator.pageIndex,
      this.paginator.pageSize
    );
    this.isLoading = true;
    console.log(JSON.stringify(queryParams));
    console.log(`sort active: ${this.sort.active}`);
    console.log(`default sort active: ${this.defaultSortActive}`);
    // console.log(JSON.stringify(this.columnList));
    this.getPageEvent.emit(queryParams);
    
    // Call request from server
    // console.log("loadMachineList");
    // this.store.dispatch(new MachineGetPage({ page: queryParams }));
    // this.selection.clear();
  }

  subscribeToLoadItem(){
    this.subscriptions.push(
      this.dataObs.pipe(
        filter((res)=>res!=null)
        // take(1)
      ).subscribe((res:any)=>{
        this.itemList = res.items;
        // this.itemList.length = res.totalCount;
				// console.log(`items: ${JSON.stringify(this.itemList)}`);
        // console.log(`total count: ${res.totalCount}`);
        this.paginator.length = res.totalCount;
        if(!this.datasource){
          this.datasource = new MatTableDataSource(this.itemList);        
          // this.datasource.paginator = this.paginator;
        }else{
          this.datasource.data = this.itemList;
          // this.datasource.paginator = this.paginator;
        }
        // this.datasource.sort = this.sort;
        this.datasource._updateChangeSubscription();
        this.paginator.length = res.totalCount;
        this.itemCount = res.totalCount;
        this.cdr.detectChanges();
        this.isLoading = false;
        // this.paginator.pageIndex = 0;
        
      })
    );
  }

  /**
   * Returns object for filter
   */
  filterConfiguration(): any {
    const filter: any = {};
    // const searchText: string = this.searchInput.nativeElement.value;
    // filter.search = searchText;

    // if(this.filterProductType!="-1"){
    //   filter.product_type_id = this.filterProductType;
    // }
    // if(this.filterProductVariety!="-1"){
    //   filter.product_variety_id = this.filterProductVariety;
    // }
    // if(this.filterSpecie!="-1"){
    //   filter.product_specie_id = this.filterSpecie;
    // }
    // if(this.filterPackaging!="-1"){
    //   filter.product_packaging_id = this.filterPackaging;
    // }
    // if(this.filterPackagingWeight!="-1"){
    //   filter.product_packaging_weight_id = this.filterPackagingWeight;
    // }
    // if(this.filterColour!="-1"){
    //   filter.product_colour_id = this.filterColour;
    // }
    // if(this.filterItem!="-1"){
    //   filter.product_item_id = this.filterItem;
    // }
    // if(this.filterProcess!="-1"){
    //   filter.product_process_id = this.filterProcess;
    // }
    // if(this.filterStatus!="-1"){
    //   filter.status_id = this.filterStatus;
    // }
    // filter.name = searchText;
    this.filterList.forEach(filterElement=>{
      const value = filterElement.value;
      if(value !== "-1" && value !== null && value !== undefined && value !== '') {
        filter[filterElement.name] = value;
      }
    })
    return filter;
  }

  isNumber(value){
    return value?typeof(value).toLocaleString() == 'number':false;
  }

  clearDateFilter(filter){
    filter.value = null;
    this.loadItemList();
  }

  toggleExpandedRow(row: any, event: Event = null) {
    if(event) event.stopPropagation();
    if(!this.expandableRows || !this.detailTemplate) return;
    this.expandedElement = this.expandedElement === row ? null : row;
  }

  isExpanded(row: any) {
    return this.expandedElement === row;
  }

  getActionTemplateContext(item: any): any {
    return {
      $implicit: item,
      item,
      table: this
    };
  }

  editItem(itemId: number){
    const editRoute = this.editRoute || `${this.route}/edit`;
    this.router.navigateByUrl(`${editRoute}/${itemId}`);
  }

  createItem() {
    const addRoute = this.addRoute || `${this.route}/add`;
    this.router.navigateByUrl(addRoute);
  }

  deleteItem(itemId: number){
    const _title = `Eliminar registro de ${this.name}`;
    const _description = `Está usted seguro de que desea eliminar permanentemente este registro de ${this.name}?`;
    const _waitDesciption = `El registro de ${this.name} se está eliminando...`;
    const _deleteMessage = `El registro de ${this.name} ha sido eliminada`;

    const dialogRef = this.layoutUtilsService.deleteElement(_title, _description, _waitDesciption);
    dialogRef.afterClosed().subscribe(res => {
      if (!res) {
        return;
      }
      this.deleteOneEvent.emit(itemId);
      this.subscriptions.push(
        this.deleteObs.pipe(
          filter(res=>res!=null),
          take(1)
        ).subscribe((status)=>{
          if(status && status == "success"){
            this.loadItemList();
            this.layoutUtilsService.showActionNotification(_deleteMessage, MessageType.Delete);
          }
        })
      )      
    });
  }
}
